import React, { useEffect, useState } from "react";
import { MwButton, MwSpinner, NoDataFound } from "../../../components/ui";
import {
  FaTimes,
  FaFilePdf,
  FaPrint,
  FaArrowUp,
  FaArrowDown,
  FaFileExcel,
  FaRegFileExcel,
} from "react-icons/fa";
import { MdDelete, MdEditNote } from "react-icons/md";
import handleConvertToPDF from "../../../utils/handleConvertToPDF";
import { useCurrent, useDelete, useFetch } from "../../../hooks";
import { useTranslation } from "react-i18next";
import DeleteConfirmationModal from "../../../components/OsRequisition/RequisitionComponents/DeleteConfirmationModal";
import * as XLSX from "xlsx";

const WarehouseView = ({ warehouse, onCancel, onEdit, onDelete }) => {
  const [t] = useTranslation("global");
  const [isContentReady, setIsContentReady] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const {
    deleteItem,
    loading: deleteLoading,
    error: deleteError,
  } = useDelete();
  const { currentTenantId, currentCompanyId, currentBranchId, userName } =
    useCurrent();
  const { data: warehouseItems, loading: itemsLoading } = useFetch(
    warehouse && warehouse.data?.id
      ? `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/warehouses/items/${currentTenantId}/${currentCompanyId}/${currentBranchId}/${warehouse.data.id}`
      : null,
    { refreshInterval: false },
  );

  console.log("warehouse?.data?.id", warehouse?.data?.id);

  // أضف function جديدة للحذف
  const handleDelete = (id) => {
    setDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await deleteItem(
        `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/warehouses/${warehouse.data?.id}`,
      );
      setDeleteModalOpen(false);
      onDelete(warehouse.data?.id); // للرجوع للصفحة الرئيسية
    } catch (error) {
      console.error("Error deleting warehouse:", error);
    }
  };
  useEffect(() => {
    if (warehouse) {
      console.log("Warehouse Data osama:", warehouse);
    }
  }, [warehouse]);

  useEffect(() => {
    if (warehouse?.data && warehouseItems?.data && !itemsLoading) {
      setTimeout(() => {
        setIsContentReady(true);
      }, 1000);
    } else {
      setIsContentReady(false);
    }
  }, [warehouse, warehouseItems, itemsLoading]);

  const handlePrint = () => {
    const printContents =
      document.getElementById("printable-content").outerHTML;
    const printWindow = window.open("", "_blank");
    printWindow.document.open();

    printWindow.document.write(`
            <!DOCTYPE html>
            <html dir="rtl" lang="ar">
              <head>
                <title>إذن مخزني</title>
                <style>
                  /* إعدادات الصفحة للطباعة */
                  @page {
                    size: A4;
                    margin: 1.5cm;
                  }
                  body {
                    font-family: 'Arial', sans-serif;
                    margin: 0;
                    padding: 0;
                    direction: rtl;
                    text-align: right;
                    color: #000;
                    print-color-adjust: exact;
                    -webkit-print-color-adjust: exact;
                  }
                   ${Array.from(document.styleSheets)
                     .map((sheet) => {
                       try {
                         return Array.from(sheet.cssRules)
                           .map((rule) => rule.cssText)
                           .join("");
                       } catch (e) {
                         return "";
                       }
                     })
                     .join("")}
                </style>
              </head>
              <body>
                ${printContents}
                <script>
                  window.onload = function () {
                    window.print();
                    window.onafterprint = function () {
                      window.close();
                    };
                  };
                </script>
              </body>
            </html>
          `);
    printWindow.document.close();
  };

  if (!isContentReady) {
    return (
      <div className="flex justify-center items-center   bg-slate-100">
        <MwSpinner size="lg" />
      </div>
    );
  }
  const calculateTotal = (items) => {
    return items.reduce((total, item) => {
      const value = Number(item.qty) || 0;
      return item.type?.trim() === "PULL" ? total - value : total + value;
    }, 0);
  };

  if (!warehouseItems?.data) {
    return <NoDataFound msg={t("deleted.no_product_in_warehouses")} />;
  }

  const exportExcel = () => {
    if (warehouseItems?.data && warehouseItems.data.length > 0) {
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(warehouseItems.data);
      XLSX.utils.book_append_sheet(wb, ws, t("reports.Warehouse_Report"));
      XLSX.writeFile(wb, `${t("reports.Warehouse_Report")}.xlsx`);
    }
  };

  console.log("warehouseItems?.data", warehouseItems?.data);

  return (
    <div className=" h-[64vh] flex   flex-col my-5   ">
      <div className="bg-white  rounded-lg p-y flex justify-between">
        <div className="mb-6 w-full flex justify-between items-center ">
          {/* مجموعة أدوات التصدير */}
          <div className="flex items-center gap-1">
            <div className="px-2 text-[#251658]"></div>
            <div className="p-3 text-[#251658]">
              <ul className="flex gap-1">
                <li
                  style={{ cursor: "pointer" }}
                  onClick={exportExcel}
                  className="px-2 py-1 flex rounded items-center gap-2 bg-slate-100 hover:font-bold"
                >
                  <FaRegFileExcel />
                  <span className="text-sm text-[#251658]">
                    {t("reports.Export_Excel")}
                  </span>
                </li>
                <li
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    handleConvertToPDF({
                      lang: "ar",
                      elementId: "printable-content",
                      fileName: `مستودع_${warehouse.data?.code}.pdf`,
                    })
                  }
                  className="px-2 py-1 flex items-center gap-1 bg-slate-100 hover:font-bold"
                >
                  <FaFilePdf />
                  <span className="text-sm text-[#251658]">
                    {t("reports.Save_as_PDF")}
                  </span>
                </li>
                <li
                  style={{ cursor: "pointer" }}
                  onClick={handlePrint}
                  className="px-2 py-1 flex items-center gap-1 bg-slate-100 hover:font-bold"
                >
                  <FaPrint />
                  <span className="text-sm text-[#251658]">
                    {t("reports.Print")}
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="flex gap-2 items-center px-6  ">
            <MwButton
              actionType="button"
              inGroup={true}
              size="sm"
              type="cancelBtn"
              onClick={() => handleDelete(warehouse.data?.id)}
            >
              <MdDelete />
              {t("requisition.delete")}
            </MwButton>

            <MwButton
              actionType="button"
              size="sm"
              inGroup={true}
              type="saveBtn"
              onClick={() => onEdit(warehouse.data?.id)}
            >
              <MdEditNote />
              {t("requisition.edit")}
            </MwButton>
          </div>
        </div>
      </div>
      <div className="flex-1 h-[90%] overflow-y-scroll custom-scrollbar">
        <div
          id="printable-content"
          className="p-8 bg-white shadow-sm  rounded-lg  my- print:rtl print:text-center will-change-transform"
        >
          <div className="text-center mb-8 border-b pb-6">
            <h1 className="text-2xl font-bold mb-2 text-[#251658]">
              {" "}
              {t("requisition.store_details")}{" "}
            </h1>
          </div>

          <div className="grid grid-cols-3 gap-8 mb-8">
            {/* العمود الأول - معلومات النظام */}
            <div className="space-y-4">
              <h2 className="text-lg font-semibold border-b pb-2 mb-3 text-[#251658]">
                {t("requisition.system_information")}
              </h2>
              <div className="text-gray-700">
                <span className="font-medium ">
                  {t("requisition.warehouse_code")}:{" "}
                </span>
                <span className="font-semibold">{warehouse.data?.code}</span>
              </div>
              <div className="text-gray-700">
                <span className="font-medium">
                  {t("requisition.warehouse_name_ar")}:{" "}
                </span>
                {warehouse.data?.name_ar}
              </div>
              <div className="text-gray-700">
                <span className="font-medium">
                  {t("requisition.warehouse_name_en")}:{" "}
                </span>
                {warehouse.data?.name_en}
              </div>
            </div>

            {/* العمود الثاني - الإحصائيات */}
            <div className="space-y-4">
              <h2 className="text-lg font-semibold border-b pb-2 mb-3 text-[#251658]">
                {t("requisition.status_information")}
              </h2>
              <div className="text-gray-700">
                <span className="font-medium">
                  {t("requisition.product_count")}:{" "}
                </span>
                {warehouseItems?.data?.length}
              </div>
              <div className="text-gray-700">
                <span className="font-medium">{t("requisition.status")}: </span>
                {warehouse.data?.is_active
                  ? t("requisition.active")
                  : t("requisition.inactive")}
              </div>
            </div>

            {/* العمود الثالث - المعلومات الأساسية */}
            <div className="space-y-4">
              <h2 className="text-lg font-semibold border-b pb-2 mb-3 text-[#251658]">
                {t("requisition.basic_information")}
              </h2>
              <div className="text-gray-700">
                <span className="font-medium">
                  {t("requisition.creation_date")}:{" "}
                </span>
                {new Date(warehouse.data?.created_at).toLocaleDateString(
                  "ar-SA",
                )}
              </div>
              <div className="text-gray-700">
                <span className="font-medium">
                  {t("requisition.created_by")}:{" "}
                </span>
                {userName}
              </div>
            </div>
          </div>
          {/* Items Table */}
          {warehouseItems?.data.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full border-collapse print:text-sm">
                <thead>
                  <tr className="bg-gray-100 !text-[#251658]">
                    <th className="border p-3 text-center w-1/12">#</th>
                    <th className="border p-3 text-center w-1/12">
                      {t("requisition.number")}
                    </th>
                    <th className="border p-3 text-center w-4/12">
                      {t("requisition.product_name")}
                    </th>
                    <th className="border p-3 text-center w-1/12">
                      {t("requisition.product_uom")}
                    </th>
                    <th className="border p-3 text-center w-1/12">
                      {t("requisition.quantity")}
                    </th>
                    <th className="border p-3 text-center w-1/12">
                      {t("requisition.date")}
                    </th>
                    <th className="border p-3 text-center w-1/12">
                      {t("requisition.transaction_type")}
                    </th>
                  </tr>
                </thead>
                <tbody className="text-sm">
                  {warehouseItems?.data?.map((item, index) => (
                    <tr key={item.id} className="hover:bg-gray-50">
                      <td className="border p-3 text-center text-[#251658] min-w-[50px]">
                        {index + 1}
                      </td>
                      <td className="border p-3 text-center text-[#251658] min-w-[50px]">
                        {item.requisition_master_id || "-"}
                      </td>
                      <td className="border p-3   text-[#251658] min-w-[120px] max-w-[200px] truncate">
                        {item.product_name?.trim() || "-"}
                      </td>
                      <td className="border p-3 text-center text-[#251658] min-w-[100px]">
                        {item.product_uom_name?.trim() || "-"}
                      </td>
                      <td className="border p-3 text-center text-[#251658] min-w-[80px] whitespace-nowrap">
                        {item.qty}
                      </td>
                      <td className="border p-3 text-center text-sm text-[#251658] min-w-[80px] whitespace-nowrap">
                        {(item.created_at && item.created_at.split("T")[0]) ||
                          "-"}
                      </td>
                      <td className="border p-3 text-center text-sm text-[#251658]">
                        <div className="flex justify-center items-center gap-2">
                          {item.type?.trim() === "PULL" ? (
                            <>
                              <span>
                                {t("reports.Permission_Disbursement")}
                              </span>
                              <FaArrowDown className="text-red-600 w-4 h-4" />
                            </>
                          ) : item.type?.trim() === "PUSH" ? (
                            <>
                              <span>{t("reports.Permission_Receipt")}</span>{" "}
                              {/* أضفنا span هنا */}
                              <FaArrowUp className="text-green-600 w-4 h-4" />
                            </>
                          ) : (
                            <span className="text-gray-500">{item.type}</span>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <NoDataFound msg={t("deleted.no_product_in_warehouses")} />
          )}

          {/* Footer - Signatures */}
          <div className="mt-12 grid grid-cols-3 gap-8 text-center">
            <div className="space-y-8">
              <div className="font-semibold text-[#251658]">
                {t("requisition.recipient")}{" "}
              </div>
              <div className="border-t pt-2 text-[#251658]">
                {t("requisition.signature")} : _____________
              </div>
            </div>
            <div className="space-y-8">
              <div className="font-semibold text-[#251658]">
                {" "}
                {t("requisition.storekeeper")}
              </div>
              <div className="border-t pt-2 text-[#251658]">
                {" "}
                {t("requisition.signature")}: _____________
              </div>
            </div>
            <div className="space-y-8">
              <div className="font-semibold text-[#251658]">
                {" "}
                {t("requisition.responsible_manager")}{" "}
              </div>
              <div className="border-t pt-2 text-[#251658]">
                {t("requisition.signature")}: _____________
              </div>
            </div>
          </div>
        </div>
      </div>
      <DeleteConfirmationModal
        isOpen={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
        loading={deleteLoading}
        title="حذف المستودع" // إضافة عنوان
        message="هل أنت متأكد من حذف هذا المستودع؟" // إضافة رسالة التأكيد
      />
    </div>
  );
};

export default WarehouseView;
